
const arr = ['~', '`', '!', '#', '$', '%', '^', '&', '*', '(', ')', '-', '_', '+', '=', '', ';', ':', '<', ',', '>', '/', '?', '|', '[', ']', '{', '}', '"', "'",'@','^','#','.']

export const blockInvalidCharForText = e => arr.includes(e.key) && e.preventDefault();